module.exports = __webpack_public_path__ + "img/11.adbf51dd.png";